import { isKnownIfasDriverRole, isKnownIfasRole } from "./ifasAccess";

export const normalizeRole = (role: any) =>
  String(role || "")
    .trim()
    .toLowerCase()
    .replace(/[\s-]+/g, "_");

export const isIfasRole = (role: any) => isKnownIfasRole(role);

export const isIfasDriverRole = (role: any) => isKnownIfasDriverRole(role);

export const getWorkspaceByRole = (role: any): "ifas" | "claims" =>
  isIfasRole(role) ? "ifas" : "claims";
